<template>
  <div class="window-f-box">
    <ul class="metro">
      <li @click="go(item)" v-for="item in list" :key="item.name">
        <i class="iconfont" :class="item.icon"></i>
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script setup>
  // import { ref } from 'vue';
  import { useRouter } from 'vue-router'
  const router = useRouter()
  const list = [
    {
      name: 'Md_Route',
      icon: 'icon-imglocroute',
      url: '/shipment/master-data?type=0',
    },
    {
      name: '',
      icon: '',
      url: '',
    },
    {
      name: '',
      icon: '',
      url: '',
    },
    {
      name: '',
      icon: '',
      url: '',
    },
    {
      name: 'Md Job & Packing',
      icon: 'icon-wuliaomingxi',
      url: '/shipment/master-data?type=1',
    },
  ]
  const go = (item) => {
    router.push(item.url)
  }
</script>
<style lang="less" scoped>
  @import '@/styles/variables.less';
  .window-f-box {
    .metro {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 487px;
      height: auto;
      margin-top: -165px;
      margin-left: -243px;
      overflow: hidden;
    }
    .metro li {
      position: relative;
      float: left;
      width: 150px;
      height: 150px;
      margin: 0 10px 10px 0;
      color: #ffffff;
      text-align: center;
      background: @gray-f;
      transition: 0.2s -webkit-transform, 1s opacity;
      transform: perspective(600px);
      transform-style: preserve-3d;
      transform-origin: 50%;
    }

    .metro li i {
      display: block;
      margin: 20px 0 0;
      font-size: 54px;
    }

    .metro li span {
      position: absolute;
      bottom: 15px;
      left: 15px;
      font-size: 20px;
      color: rgba(255, 255, 255, 0.8);
    }
    .metro li:first-child {
      cursor: pointer;
      background: @started;
    }
    .metro li:nth-child(3) {
      margin-right: 0;
    }
    .metro li:last-child {
      width: 310px;
      margin: 0;
      cursor: pointer;
      background: #d1cdd5;
    }

    .metro li:last-child:active,
    .metro li:first-child:active {
      -webkit-transform: perspective(600px) rotate3d(1, 0, 0, -30deg);
      transform: perspective(600px) rotate3d(1, 0, 0, -30deg);
    }
    .master-metro {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 790px;
      transform: translate(-25%);
      li {
        cursor: pointer;
        span {
          font-size: 16px;
        }
      }
      li:active {
        -webkit-transform: perspective(600px) rotate3d(1, 0, 0, -30deg);
        transform: perspective(600px) rotate3d(1, 0, 0, -30deg);
      }
      li:first-child {
        width: 310px;
      }
      li:nth-child(4) {
        margin-right: 0;
      }
      li:nth-child(2) {
        background: @leveled;
      }
      li:nth-child(3) {
        margin-right: 10px;
        background: @planned;
      }
      li:nth-child(6) {
        background: #d1cdd5;
      }
      li:nth-child(7) {
        background: @darkcyan;
      }
      li:nth-child(4),
      li:nth-child(5) {
        background: @coral;
      }
    }
  }

  .window-f-box .metro li:last-child {
    background: #5ca9d6;
  }
</style>
